import React, { useEffect, useState } from 'react';
import { Box, Flex, SimpleGrid, Image, Badge, Button, Text, Heading, Spinner, Center, Tabs, TabList, Tab, Modal, ModalOverlay, ModalContent, ModalBody, useDisclosure } from '@chakra-ui/react';
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://xlgbokglmvtwrgyjoegq.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhsZ2Jva2dsbXZ0d3JneWpvZWdxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzMjAwMTksImV4cCI6MjA2Mzg5NjAxOX0.f3pvp_DO_0qHRIHjixoqPVLq1uKn0NslnauiaSIvLy0';
const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

const PAGE_SIZE = 6;

export default function Portfolio() {
  const [websites, setWebsites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('All');

  // Fetch all data for filtering and pagination
  const [allWebsites, setAllWebsites] = useState([]);

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('portfolio')
        .select('*')
        .order('createdAt', { ascending: false });
      if (!error) {
        setAllWebsites(data || []);
      }
      setLoading(false);
    };
    fetchAll();
  }, []);

  // Filtered websites by category
  const filteredWebsites = selectedCategory === 'All'
    ? allWebsites
    : allWebsites.filter(site => site.category === selectedCategory);

  // Pagination logic for filtered data
  const totalPages = Math.ceil(filteredWebsites.length / PAGE_SIZE);
  const paginatedWebsites = filteredWebsites.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  // Unique categories for tabs
  const categories = ['All', ...Array.from(new Set(allWebsites.map(site => site.category).filter(Boolean)))];

  const handleTabChange = idx => {
    setSelectedCategory(categories[idx]);
    setPage(1); // Reset to first page on filter change
  };

  const handleNext = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  };
  const handlePrev = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <div className="portfolio" style={{ width:'100%', minHeight: '100vh', width: '100vw', overflowX: 'hidden' ,backgroundColor:'#F7C873'}}>
      <Box w="100vw" minH="100vh" py={10} px={{base:'10px',md:'50px'}}>
        <Heading as='h2' size={{ base: '2xl', md: '3xl' }} marginBottom={{base:'50px',md:'100px'}} marginTop={{base:'50px',md:'100px'}} textAlign={'center'} fontFamily="EB Garamond" color={'black'} fontWeight={'400'}>
          Signature Projects
        </Heading>
        <Tabs variant="soft-rounded" colorScheme="orange" onChange={handleTabChange} mb={8}>
          <TabList>
            {categories.map(cat => (
              <Tab key={cat}>{cat}</Tab>
            ))}
          </TabList>
        </Tabs>
        {loading ? (
          <Center h="60vh"><Spinner size="xl" /></Center>
        ) : (
          <SimpleGrid columns={[1, 2, 3]} spacing={8}>
            {paginatedWebsites.map(site => (
              <Box key={site.id} bg="#F7C873" rounded="lg" shadow="md" overflow="hidden" border={"#96620288 2px solid"} p={4}>
                {site.imageUrl && (
                  <Image
                    src={site.imageUrl}
                    alt={site.title}
                    w="100%"
                    h="500px"
                    objectFit="cover"
                    mb={3}
                    cursor="pointer"
                    onClick={() => { setSelectedImage(site.imageUrl); onOpen(); }}
                  />
                )}
                <Badge colorScheme="orange" variant="solid" mb={2}>{site.category}</Badge>
                <Heading size="md" mb={2}>{site.title}</Heading>
                <Text mb={3}>{site.description}</Text>
                {site.url && site.url !== '#' && (
                  <Button as="a" href={site.url} target="_blank" colorScheme="orange" size="sm">Visit</Button>
                )}
              </Box>
            ))}
          </SimpleGrid>
        )}
        <Flex justify="center" align="center" mt={8} gap={4}>
          <Button onClick={handlePrev} isDisabled={page === 1}>Previous</Button>
          <Text>Page {page} / {totalPages || 1}</Text>
          <Button onClick={handleNext} isDisabled={page === totalPages || totalPages === 0}>Next</Button>
        </Flex>
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
          <ModalOverlay />
          <ModalContent bg="transparent" boxShadow="none">
            <ModalBody p={0} display="flex" justifyContent="center" alignItems="center">
              {selectedImage && (
                <Image src={selectedImage} alt="Enlarged" maxH="80vh" maxW="90vw" borderRadius="lg" />
              )}
            </ModalBody>
          </ModalContent>
        </Modal>
      </Box>
    </div>
  );
}